/**
 * Ory Network connect field validation (POST-ARC.12a).
 */

const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
const API_KEY_RE = /^ory_(?:pat|apikey)_/i;

/**
 * @param {string | null | undefined} raw
 */
export function normalizeOryProjectSlugInput(raw) {
  let s = String(raw || "").trim().toLowerCase();
  s = s.replace(/^https?:\/\//, "");
  const hostMatch = s.match(/^([a-z0-9][a-z0-9-]*)\.projects\.oryapis\.com/);
  if (hostMatch) s = hostMatch[1];
  s = s.replace(/\/.*$/, "");
  return s;
}

/**
 * @param {{ project_slug?: string, api_key?: string }} fields
 */
export function validateOryConnectFields(fields) {
  const project_slug = normalizeOryProjectSlugInput(fields?.project_slug);
  const api_key = String(fields?.api_key || "").trim();

  if (!project_slug) {
    return { ok: false, error: "Ory project slug is required." };
  }
  if (!SLUG_RE.test(project_slug)) {
    return { ok: false, error: "Enter a valid Ory project slug (lowercase letters, numbers, hyphens)." };
  }
  if (!api_key) {
    return { ok: false, error: "Project API key is required." };
  }
  if (!API_KEY_RE.test(api_key)) {
    return { ok: false, error: "API key must be an Ory Project API key (ory_pat_ or ory_apikey_ prefix)." };
  }
  return { ok: true, project_slug, api_key };
}

/**
 * @param {Record<string, unknown>} data
 */
export function mapOryConnectApiError(data) {
  if (typeof data?.error === "string" && data.error.trim()) return data.error;
  return "Connection failed";
}
